import { createApi } from "@reduxjs/toolkit/query/react";
import { VITE_API_V2_URL } from "codes";
import { axiosBaseQuery } from "helpers/axiosbaseQuery";

import type { RiskCategoryExposure, InsurerExposure, CountryExposure, IndustryExposure } from "./api-risk-dashboard.d";

/**
 * Creates an API instance for handling risk dashboard-related operations.
 *
 * @returns The risk dashboard API instance.
 */

export const riskDashboardApi = createApi({
  reducerPath: "riskDashboard",
  tagTypes: ["RiskDashboard"],
  baseQuery: axiosBaseQuery({
    baseUrl: VITE_API_V2_URL,
  }),
  endpoints: (builder) => ({
    getRiskCategoryExposure: builder.query<RiskCategoryExposure[], void>({
      query: () => ({
        url: "/dashboard/by/risk-category",
        method: "GET",
      }),
      providesTags: ["RiskDashboard"],
    }),
    getInsurerExposure: builder.query<InsurerExposure[], void>({
      query: () => ({
        url: "/dashboard/by/insurer",
        method: "GET",
      }),
      providesTags: ["RiskDashboard"],
    }),
    getCountryExposure: builder.query<CountryExposure[], void>({
      query: () => ({
        url: "/dashboard/by/country",
        method: "GET",
      }),
      providesTags: ["RiskDashboard"],
    }),
    getIndustryExposure: builder.query<IndustryExposure[], void>({
      query: () => ({
        url: "/dashboard/by/industry",
        method: "GET",
      }),
      providesTags: ["RiskDashboard"],
    }),
    getInvoiceOverdueDays: builder.query<any, void>({
      query: () => ({
        url: '/dashboard/by/invoice_overdue_days',
        method: 'GET',
      }),
    }),
    getOutstandingCreditLimit: builder.query<{ data: Array<{
      buyer_name: string;
      total_approved_requested_credit_limit: number;
      buyer_outstanding_limit: number;
    }> }, void>({
      query: () => ({
        url: '/dashboard/outstanding-credit-limit',
        method: 'GET',
      }),
      providesTags: ["RiskDashboard"],
    }),
  }),
});

export const {
  useGetRiskCategoryExposureQuery,
  useGetInsurerExposureQuery,
  useGetCountryExposureQuery,
  useGetIndustryExposureQuery,
  useGetInvoiceOverdueDaysQuery,
  useGetOutstandingCreditLimitQuery,
} = riskDashboardApi;
